import React, { Fragment } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { getVehicleStatus } from '@utils';
import { updateActiveVehicle } from '@store/userProfileSlice';
import { getLocalizedContent as l } from '@helpers/languages';
import content from './MultiVehicleNav.json';
import styles from './MultiVehicleNav.module.scss';
import VehicleImage from './VehicleImage';
import { getLanguagePrefix } from '@helpers';

const MultiVehicleNavList = ({ isDropdownShowing }) => {
  const { user, prefixLanguage, language } = useSelector(
    ({ appState, userProfile }) => ({
      ...appState,
      ...userProfile,
    })
  );

  const { vehicles } = user;

  const dispatch = useDispatch();
  const selectVehicle = index => {
    dispatch(updateActiveVehicle(index));
    window.location.assign(
      `${window.location.origin}${getLanguagePrefix(
        prefixLanguage
      )}/portal/dashboard`
    );
  };

  return (
    <nav
      className={[
        styles.portalDropdown,
        isDropdownShowing && styles.isActive,
      ].join(' ')}
    >
      {vehicles &&
        vehicles.map(
          (vehicle, index) =>
            !['CANCELLATION_COMPLETED', 'CANCELLATION_INITIATED'].includes(
              vehicle.status
            ) && (
              <Fragment key={`${vehicle.configName}_${index}`}>
                <button
                  onClick={() => {
                    selectVehicle(index);
                  }}
                  className={styles.portalDropBtn}
                >
                  <VehicleImage shortcode={vehicle.shortcode} />
                  <span className={styles.carTitle}>
                    {vehicle.configName || l(content.defaultNickName, language)}
                    <br />
                    {l(getVehicleStatus(vehicle), language)}
                  </span>
                </button>
              </Fragment>
            )
        )}
    </nav>
  );
};

export default MultiVehicleNavList;
